import { render, staticRenderFns } from "./RootContabilitaCronologiaView.vue?vue&type=template&id=fa9f7b52&"
import script from "./RootContabilitaCronologiaView.vue?vue&type=script&lang=ts&"
export * from "./RootContabilitaCronologiaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports